export default {
  apiUrl: 'https://api-stage.getfloorplan.tech',
  apiBovwUrl: 'https://bovw.srv.getfloorplan.com',
  apiControlPanel: 'https://panel.getfloorplan.tech',
  apiControlPanelToken: '44c5060cc2b3f29e38b9eb3ed67e0671c7556a6a',
  appUrl: 'https://backoffice-stage.getfloorplan.tech',
  publicUrl: 'https://stage.getfloorplan.com/public_fp',
  bitrixUrl: 'https://hartestate.bitrix24.ru',
  jenkinsUrl: 'https://jenkins.hart-digital.com',
  guardsGuideUrl: 'https://docs.getfloorplan.tech/doc/kak-napisat-proverku-planirovki-fVWVtPpFVg',
  baseDomain: 'getfloorplan.tech',
  appEnv: 'stage',
  widget: {
    url: 'https://base.hart-estate.ru',
    gltfUrl: 'https://gltf.floor-plan.online',
    logoUrl: 'https://hart-estate.ru',
    logoUrlEn: 'https://getfloorplan.com/',
  },
  brandingWidgetQueryParams: 'crmPlanId=194169&rotationMode=1&env=stage&noCache=1',
  brandingGltfWidgetQueryParams: 'id=e6be5d7c-849c-4dd2-8066-85dc28eb934d&env=stage&noCache=1',
  pusher: {
    appKey: 'c58c7bbf1f4039222764',
    appCluster: 'eu',
  },
  sentry: {
    environment: 'stage',
    dsn: 'https://c3e93a73dc4ee92a34a7ec24160467a4@sentry.hart-digital.com/2',
    url: 'https://sentry.hart-digital.com',
    project: 'backoffice',
    org: 'org',
  },
  featureFlagsOverride: {
    isEnvironmentVisible: true,
    isBrandingVisible: true,
    isWidgetMaterialVisible: true,
    isGenerationCrmPlan3dResultHighVisible: true,
    isCustomersVisible: true,
    isDatasetSelectionPlansVisible: true,
    isCanGetPlansToWorkVisible: true,
    isHasPanoramaCheckboxVisible: true,
    isBetaTestingCheckboxVisible: true,
    isWaitDurationVisible: true,
    isWidgetLinkConstructorVisible: true,
    isSamePlansAiVisible: true,
    isPlanDescriptionAndRendersVisible: true,
    isNewPlanOptionsVisible: true,
    isProactiveModeVisible: false,
    isPortalModeVisible: true,
    isSingleFloorCuttingVisible: false,
    isRenovationCheckboxVisible: false,
    isUnrealAdminPanelVisible: true,
    isUnrealTopDownCountVisible: true,
    isPngLosslessFormatChoiceVisible: true,
    isNinjaPlansLimitVisible: true,
    isPanoramasTypeChoiceVisible: true,
    isMiddleCutHeightChoiceVisible: true,
    isCameraIsoChoiceVisible: true,
    isGltfConfigEditorVisible: true,
    isQualityReviewPanelsVisible: true,
    isGuardsVisible: true,
    isPlanRevisionsVisible: true,
  },
  yandexMetrika: {
    counterId: 97097353,
    initOptions: {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
    },
  },
  waitDuration: 200,
  renderServers: {
    'По умолчанию': 'HDET',

    UnrealUltraHigh: 'UnrealUltraHigh',
    UnrealHigh: 'UnrealHigh',
    UnrealMedium: 'UnrealMedium',
    UnrealLow: 'UnrealLow',
    UnrealPreview: 'UnrealPreview',

    4090: '4090',
    1060: '1060',
  },
  declineReasons: {
    two_floors: { ru: 'Двухэтажная планировка', en: 'Two-storey floor plan' },
    cropped: { ru: 'Обрезанная планировка', en: 'Cropped floor plan' },
    unreadable: { ru: 'Нечитаемая планировка', en: 'Unreadable floor plan' },
    missing: { ru: 'Планировка отсутствует', en: 'Floor plan is missing' },
    other: { ru: 'Другое', en: 'Other' },
  },
  bottomTags: ['CIAN/\\d{4}\\.\\d{2}\\.\\d{2}'],
  isSnowing: false,
  navbarVisibleTabs: {
    crm: [
      '/crm/my-plans',
      '/crm/ninja-board',
      '/crm/reviews',
      '/crm/plans/cutting',
      '/crm/plans',
      '/crm/upload',
      '/crm/search',
      '/crm/apartments',
      '/crm/production-matrix',
      '/crm/production-matrix/schedule',
      '/crm/statistic/ninja',
      '/crm/customers',
      '/crm/payroll',
      '/crm/payroll/employees',
      '/crm/work-schedule',
    ],
    service: [
      '/service',
      '/plans',
      '/batch-actions',

      '/users/list',
      '/users/register',
      // '/design-files',
      '/quality/checklists',
      '/quality/guards',
      '/quality/issue-categories',
      '/crm/customers',
      '/integrations/brandings',
      '/integrations/webhooks',

      '/library/furniture/svg',
      '/library/furniture/unreal/objects',
      '/library/furniture/unreal/tags',
      '/library/furniture/unreal/tags/categories',
      '/library/furniture/unreal/groups',
      '/library/materials/objects',
      '/library/materials/tags',
      '/library/apertures/objects',
      '/library/apertures/tags',
      '/library/moldings/objects',
      '/library/moldings/tags',
      '/library/styles/list',
      '/library/styles/presets',
      '/library/room-types',
      '/library/environments',
    ],
  },
  modules: {
    render_gltf: {
      fileSources: {
        cdns: [
          { id: 'cdn4', label: 'CDN', url: 'https://cdn4.getfloorplan.tech' },
        ],
      },
      defaults: {
        geometryQuality: 'Low',
        lightmapsQuality: 'Low',
        textureImageFormat: 'PNG',
        textureImageQuality: 90,
        buildLighting: true,
        styleId: null,
        environmentMap: null,
        widgetTexturePacks: [
          'medium',
          'low',
        ],
        postprocessJobs: [
          'raw',
          'widget',
        ],
      },
      validations: [
        {
          type: 'required',
          field: 'styleId',
          message: 'Выберите стиль',
        },
        {
          type: 'required',
          field: 'widgetTexturePacks',
          when: {
            field: 'postprocessJobs',
            includes: 'widget',
          },
          message: 'Выберите хотя бы одно качество текстур для виджета',
        },
      ],
      fields: [
        {
          id: 'geometryQuality',
          type: 'select',
          label: 'Качество геометрии',
          options: [
            'Low',
            'Medium',
            'High',
          ],
        },
        {
          id: 'lightmapsQuality',
          type: 'select',
          label: 'Качество lightmaps',
          options: [
            'Low',
            'Medium',
            'High',
          ],
        },
        {
          id: 'textureImageFormat',
          type: 'select',
          label: 'Формат исходных текстур',
          options: [
            'PNG',
            'JPEG',
            'None',
          ],
        },
        {
          id: 'textureImageQuality',
          type: 'number',
          label: 'Качество исходных текстур (%)',
          min: 0,
          max: 100,
        },
        {
          id: 'buildLighting',
          type: 'switch',
          label: 'Запекать освещение',
        },
        {
          id: 'styleId',
          type: 'select',
          label: 'Стиль',
          optionsSource: 'styles',
          placeholder: 'Выберите стиль',
          required: true,
          showSearch: true,
          allowClear: true,
          defaultSource: {
            sources: [
              {
                source: 'store',
                path: 'substances.presetsList',
                lookup: {
                  itemPath: 'id',
                  valueSource: {
                    source: 'store',
                    path: 'crm.currentPlan.preset_id',
                  },
                  resultPath: 'plan_style.id',
                },
              },
              {
                source: 'store',
                path: 'plans.current.style.id',
              },
              {
                source: 'plan',
                path: 'style.id',
              },
              {
                source: 'store',
                path: 'substances.defaultPreset.plan_style.id',
              },
              {
                defaultValue: null,
              },
            ],
          },
        },
        {
          id: 'environmentMap',
          type: 'select',
          label: 'Окружение',
          optionsSource: 'webEnvironmentMaps',
          placeholder: 'Не выбран',
          showSearch: true,
          allowClear: true,
          fileSource: true,
        },
        {
          id: 'postprocessJobs',
          type: 'multiselect',
          label: 'Результаты пост-процессинга',
          placeholder: 'Выберите результаты',
          showSearch: true,
          allowClear: true,
          optionsCatalog: 'postprocessJobs',
        },
        {
          id: 'widgetTexturePacks',
          type: 'multiselect',
          label: 'Качество текстур для виджета',
          placeholder: 'Выберите качества текстур',
          showSearch: true,
          allowClear: true,
          required: true,
          optionsCatalog: 'widgetTexturePacks',
          visibleWhen: {
            field: 'postprocessJobs',
            includes: 'widget',
          },
        },
      ],
      catalogs: {
        widgetTexturePacks: {
          high: {
            label: 'High',
            template: {
              name: 'High',
              format: 'ktx2',
              output_file: 'Widget/KTX2_High',
              env_map: {
                $if: 'environmentMap',
                $value: {
                  type: 'sphere',
                  output_files: [
                    {
                      $param: 'environmentMap',
                    },
                  ],
                },
              },
            },
            postprocessTemplate: {
              name: 'KTX2_High',
              script_alias: 'widget/ktx2-high',
            },
          },
          medium: {
            label: 'Medium',
            template: {
              name: 'Standard',
              format: 'ktx2',
              output_file: 'Widget/KTX2_Medium',
              env_map: {
                $if: 'environmentMap',
                $value: {
                  type: 'sphere',
                  output_files: [
                    {
                      $param: 'environmentMap',
                    },
                  ],
                },
              },
            },
            postprocessTemplate: {
              name: 'KTX2_Medium',
              script_alias: 'widget/ktx2-medium',
            },
          },
          low: {
            label: 'Low',
            template: {
              name: 'Optimized',
              format: 'ktx2',
              output_file: 'Widget/KTX2_Low',
              env_map: {
                $if: 'environmentMap',
                $value: {
                  type: 'sphere',
                  output_files: [
                    {
                      $param: 'environmentMap',
                    },
                  ],
                },
              },
            },
            postprocessTemplate: {
              name: 'KTX2_Low',
              script_alias: 'widget/ktx2-low',
            },
          },
        },
        postprocessJobs: {
          raw: {
            label: 'GLB Medium',
            template: {
              name: 'Raw',
              script_alias: 'raw/medium',
              script_params: {
                output_file: 'Raw/Demo.glb',
              },
              texture_packs: [],
              post_script_alias: null,
            },
          },
          widget: {
            label: 'GLTF для виджета',
            template: {
              name: 'Widget',
              script_alias: 'widget/mesh',
              script_params: {
                output_file: 'Widget/Demo.gltf',
              },
              texture_packs: {
                $selected: {
                  param: 'widgetTexturePacks',
                  catalog: 'widgetTexturePacks',
                  templateKey: 'postprocessTemplate',
                },
              },
              post_script_alias: null,
            },
          },
          fbxMedium: {
            label: 'FBX с текстурами',
            exclusiveGroup: 'fbx',
            template: {
              name: 'FBX',
              script_alias: 'fbx/medium',
              script_params: {
                output_file: 'FBX/Demo.fbx',
              },
              texture_packs: [],
              post_script_alias: null,
            },
          },
          fbxNoTexture: {
            label: 'FBX без текстур',
            exclusiveGroup: 'fbx',
            template: {
              name: 'FBX_NoTexture',
              script_alias: 'fbx/no-texture',
              script_params: {
                output_file: 'FBX/Demo_NoTexture.fbx',
              },
              texture_packs: [],
              post_script_alias: null,
            },
          },
          fbxArchive: {
            label: 'FBX с текстурами в архиве',
            exclusiveGroup: 'fbx',
            template: {
              name: 'FBX_Archive',
              script_alias: 'fbx/archive',
              script_params: {
                output_file: 'FBX/Demo_NoTexture.zip',
              },
              texture_packs: [],
              post_script_alias: null,
            },
          },
        },
      },
      template: {
        version: 1,
        unreal: {
          version: 1,
          jobs_overrides: {
            'Jobs.0.GeometryQuality': {
              $param: 'geometryQuality',
            },
            'Jobs.0.Tasks.0': {
              Name: 'Demo',
              Type: 'ExportToGLTF',
              Format: 'GLTF',
              StyleIds: [
                {
                  $param: 'styleId',
                },
              ],
              BuildLighting: {
                $param: 'buildLighting',
              },
              LightmapsQuality: {
                $param: 'lightmapsQuality',
              },
              Filename: '{Task}',
              TextureImageFormat: {
                $param: 'textureImageFormat',
              },
              TextureImageQuality: {
                $param: 'textureImageQuality',
              },
            },
          },
        },
        widget: {
          $if: {
            param: 'postprocessJobs',
            includes: 'widget',
          },
          $value: {
            version: 1,
            texture_packs: {
              $selected: {
                param: 'widgetTexturePacks',
                catalog: 'widgetTexturePacks',
              },
            },
            mesh_output_file: 'Widget/Demo.gltf',
            preferred_texture_pack: 'Standard',
            optimized_texture_pack: 'Optimized',
            env_path_template: '{output_file}',
          },
        },
        postprocess: {
          version: 1,
          jobs: {
            $selected: {
              param: 'postprocessJobs',
              catalog: 'postprocessJobs',
            },
          },
        },
      },
    },
  },
};
